import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=6467a7b1&scoped=true&"
import script from "./Feedback.vue?vue&type=script&lang=ts&"
export * from "./Feedback.vue?vue&type=script&lang=ts&"
import style0 from "./Feedback.vue?vue&type=style&index=0&id=6467a7b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6467a7b1",
  null
  
)

export default component.exports